import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { environment } from '../../environments/environment';
import { NetworkServices } from '../../services/network-services';
import { UtilService } from '../../services/util';

@Injectable()
export class MeterProvider {
  
	meterURL = environment.meterUrl;
  ismURL = environment.ismUrl;

  constructor(public http: HttpClient, 
    private storage :Storage, 
    private networkServices: NetworkServices,
    private util: UtilService) {}

  getReadings(pageNo: number){
  	return this.getToken().then((val) => {
      if(val){
        return this.networkServices.get(this.v1_getUrl('meterUrl',`/v1/society/${val.societyId}/unit/${val.flat_no}/readings`), val, `&per_page=20&page_no=${pageNo}`);
        // return this.http.get<Response>(this.getUrl(this.meterURL, `/v1/society/${val.societyId}/unit/${val.flat_no}/readings`,val)+`&per_page=20&page_no=${pageNo}`)
        // .toPromise();
      }
    });
  }
  
  getConsumption(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(this.meterURL, `/v1/society/${val.societyId}/unit/${val.flat_no}/consumption`,val))
        .toPromise();
      }
    });
  }

  getStatus(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(this.meterURL, `/v1/society/${val.societyId}/unit/${val.flat_no}/meter`,val))
        .toPromise().then(val => {
          if(val.status == "success"){
            if(val.data.status && val.data.status == "UP"){
              return true;
            }else if(val.data.status == "DOWN"){
              return false;
            }
          }else{
            return true;
          }
        });
      }
    });
  }

  getDgStatus(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(this.meterURL, `/v1/society/${val.societyId}/dgstatusbysociety`,val))
        .toPromise().then(val => {
          if(val.status == "success"){
            if(val.data && val.data.status && val.data.status == "OFF"){
              return true;
            }else if(val.data && val.data.status == "ON"){
              return false;
            }
          }else{
            return true;
          }
        });
      }
    });
  }

  exportReadingBetweenDates(fromDate,toDate,unit,type){
    return this.getToken().then((val) => {
      if(val){
        let url =(this.getUrl(this.meterURL, `/v1/society/${val.societyId}/exportreading`,val)+`&from_date=`+fromDate+'&to_date='+toDate+'&unit='+unit+"&type="+type)
        this.util.openWithInAppBrowser(url);
      }
    });
  }

  getMeterActivesResponse (){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(this.meterURL, `/v1/society/${val.societyId}/unit/${val.flat_no}/livereading`,val))
        .toPromise();
      }
    });
  }

  getToken(){
    return this.storage.get("loginDetails");
  }

  getUrl(url:string, link: string, val: any):string {
    return `${url}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }

  v1_getUrl(url: string, link: string){
    return `${environment[url]}${link}`;
  }

}

export class Response{
  constructor(res){
    console.log(res);
  }
  status: string;
  message: string;
  data?: any;
  metadata?: any;
  complaintTypeList?: any;
}



// WEBPACK FOOTER //
// ./src/providers/meter/meter.ts